import React from "react";
import HeaderComponent from "../../components/header/header.component";
import { ContentLayout } from "../../layouts/content/content.layout";
import CheckpointExamContentComponent from "../../modules/educations/components/checkpoint/checkpoint-exam-content/checkpoint-exam-content.component";

const CheckpointExamPage = (props: any) => {
  const examId = props.match.params.id;

  return (
    <>
      <HeaderComponent />
      <ContentLayout>
        <CheckpointExamContentComponent examId={examId} />
      </ContentLayout>
    </>
  );
};

export default CheckpointExamPage;
